import { Link } from "@tanstack/react-router";
import { useCart } from "../context/CartContext";
import { ShoppingCart } from "lucide-react";

export function FloatingCart() {
  const { count, total } = useCart();

  if (count === 0) return null;

  return (
    <Link
      to="/cart"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-card/90 hover:bg-card border border-border/60 shadow-2xl px-5 py-3.5 rounded-full text-foreground transition-all duration-300 hover:scale-105 active:scale-95 backdrop-blur-md group hover:border-foreground/45"
    >
      <div className="relative flex items-center justify-center">
        <ShoppingCart className="h-4.5 w-4.5 transition-transform duration-300 group-hover:rotate-[-6deg]" />
        <span className="absolute -top-2.5 -right-2.5 bg-foreground text-background text-[9px] font-black h-4.5 w-4.5 rounded-full flex items-center justify-center border border-card">
          {count}
        </span>
      </div>
      <div className="flex flex-col items-start leading-none text-left pl-0.5">
        <span className="text-[8px] uppercase tracking-[0.2em] text-muted-foreground">Cart</span>
        <span className="text-[11px] font-bold mt-1 tracking-wide">
          {total > 0 ? `${total} EGP` : "Price on request"}
        </span>
      </div>
    </Link>
  );
}
